import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { Prize } from '../prize';
import { PrizeService } from '../prize.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-prize-details',
    templateUrl: './prize-details.component.html',
    styleUrls: ['./prize-details.component.scss'],
    standalone: false
})
export class PrizeDetailsComponent extends BaseComponent implements OnInit {

  public id: string;
  public prize: Prize = new Prize();

  constructor(public sessionService: SessionService,
    private route: ActivatedRoute,
    private prizeService: PrizeService,
    stringHelpers: StringHelpers) { 
    super(sessionService,stringHelpers);
  }

  ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedIteration = this.getGlobalOutingIteration();
      this.id = this.route.snapshot.paramMap.get('id');
      this.getSponsorById();
    }
  }

  getSponsorById(){
    this.prizeService.getById(this.id).subscribe(result => {
      this.prize = result;
    });
  }

}
